import React from "react";

export default function X({ color = "#424242", ...restProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={16}
      viewBox="0 0 18 16"
      {...restProps}
    >
      <path
        fill={color}
        fillRule="evenodd"
        stroke={color}
        strokeLinecap="square"
        d="M10.308 8l5.763 5.763.654.654-1.308 1.308-.654-.654L9 9.308 3.237 15.07l-.654.654-1.308-1.308.654-.654L7.692 8 1.93 2.237l-.654-.654L2.583.275l.654.654L9 6.692 14.763.93l.654-.654 1.308 1.308-.654.654L10.308 8z"
      />
    </svg>
  );
}
